export default {
  title: 'Delete job values data',
  confirmDelete: {
    header: 'Confirm deletion of data',
    message: 'Please confirm that you want to delete the values of \'{item}\' between {from} and {to}.',
  },
};
